export const isMobile = (width, height) => {
  if (width < 1000 && height > width) {
    return true;
  }
  return false;
};
